
const messages = {
    en: {
       delivery: {
          stockDaily: {
            name: 'StockDaily',
            title: 'StockDaily management',
            subtitle: 'View, search, create, edit and delete StockDaily',
            creating: 'Creating StockDaily',
            editing: 'Editing StockDaily',
            deleting: 'Deleting StockDaily',
            showing: 'Showing StockDaily',
            menu: 'StockDaily',
            labels: {
                branch: 'Branch',
                originBranch: 'Origin Branch',
                destinationBranch: 'Destination Branch',
                date: 'Date'
            },

          }
       }
    },
    es: {
       delivery: {
          stockDaily: {
            name: 'StockDaily',
            title: 'Administración de StockDaily',
            subtitle: 'Ver, buscar, crear, editar, y borrar StockDaily',
            creating: 'Creando StockDaily',
            editing: 'Modificando StockDaily',
            deleting: 'Eliminando StockDaily',
            showing: 'Detalles de StockDaily',
            menu: 'StockDaily',
            labels: {
                branch: 'Sucursal',
                originBranch: 'Sucursal Origen',
                destinationBranch: 'Sucursal Destino',
                date: 'Fecha'
            },

          }
       }
    },
    pt: {
       delivery: {
          stockDaily: {
            name: 'StockDaily',
            title: 'Administração de StockDaily',
            subtitle: 'Ver, buscar, criar, editar e usar StockDaily',
            creating: 'Criando StockDaily',
            editing: 'Edição StockDaily',
            deleting: 'Apagando StockDaily',
            showing: 'Detalhes do StockDaily',
            menu: 'StockDaily',
            labels: {
                branch: 'Sucursal',
                originBranch: 'Origin Branch',
                destinationBranch: 'Destination Branch',
                date: 'Fecha'
            },

          }
       }
    }
}

export default messages
